import {changeEvent, dispatchCustomEvent} from "../../../../../webpack/modules/events";

changeEvent('#product-popup input[name="materialColor"]', true, function(element) {
    let option = element.closest('.product-option');
    let previewElement = option.querySelector('.option-preview');

    dispatchCustomEvent(
        'productMaterialColorChanged',
        {
            'option': option,
            'previewElement': previewElement
        }
    );
});